var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevel6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 94c25.957 0 47-21.043 47-47S72.957 0 47 0 0 21.043 0 47s21.043 47 47 47Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m31 57-7.1 19.4c-.5 1.4 1 2.7 2.3 2.1l4.3-2.1c.9-.4 1.9 0 2.3.8l1.9 4.4c.6 1.4 2.6 1.3 3.1-.1l7.1-19.4",
    fill: "#FF6F6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m31 57-7.1 19.4c-.5 1.4 1 2.7 2.3 2.1l4.3-2.1c.9-.4 1.9 0 2.3.8l1.9 4.4c.6 1.4 2.6 1.3 3.1-.1l7.1-19.4",
    stroke: "#E05F5F",
    strokeWidth: 3.356,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m65.8 57 7.1 19.4c.5 1.4-1 2.7-2.3 2.1l-4.3-2.1c-.9-.4-1.9 0-2.3.8l-1.9 4.4c-.6 1.4-2.6 1.3-3.1-.1l-7-19.4",
    fill: "#FF6F6C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m65.8 57 7.1 19.4c.5 1.4-1 2.7-2.3 2.1l-4.3-2.1c-.9-.4-1.9 0-2.3.8l-1.9 4.4c-.6 1.4-2.6 1.3-3.1-.1l-7-19.4",
    stroke: "#E05F5F",
    strokeWidth: 3.356,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2 68c16.017 0 29-12.984 29-29s-12.983-29-29-29c-16.016 0-29 12.984-29 29s12.984 29 29 29Z",
    fill: "#D5EFF7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m48.6 22 3.5 7.1c.2.5.7.8 1.2.8l7.9 1.1c1.3.2 1.8 1.7.9 2.6l-5.7 5.6c-.4.4-.5.9-.4 1.4l1.3 7.8c.2 1.3-1.1 2.2-2.2 1.6l-7-3.7c-.5-.2-1-.2-1.4 0l-7 3.7c-1.1.6-2.5-.4-2.2-1.6l1.3-7.8c.1-.5-.1-1-.4-1.4l-5.7-5.6c-.9-.9-.4-2.5.9-2.6l7.9-1.1c.5-.1.9-.4 1.2-.8l3.5-7.1c.1-1.2 1.8-1.2 2.4 0ZM22 34.4l2.7 5.6c.2.4.5.6.9.7l6.1.9c1 .1 1.4 1.4.7 2.1L28 48c-.3.3-.4.7-.3 1.1l1 6.1c.2 1-.9 1.7-1.8 1.3l-5.5-2.9c-.4-.2-.8-.2-1.1 0l-5.5 2.9c-.8.3-1.8-.4-1.7-1.4l1-6.1c.1-.4-.1-.8-.3-1.1l-4.4-4.3c-.7-.7-.3-1.9.7-2.1l6.1-.9c.4-.1.7-.3.9-.7l2.7-5.6c.5-.8 1.8-.8 2.2.1Zm52.5 0 2.7 5.6c.2.4.5.6.9.7l6.1.9c1 .1 1.4 1.4.7 2.1L80.5 48c-.3.3-.4.7-.3 1.1l1 6.1c.2 1-.9 1.7-1.8 1.3l-5.4-3c-.4-.2-.8-.2-1.1 0l-5.5 2.9c-.9.5-1.9-.3-1.8-1.3l1-6.1c.1-.4-.1-.8-.3-1.1l-4.4-4.3c-.7-.7-.3-1.9.7-2.1l6.1-.9c.4-.1.7-.3.9-.7l2.7-5.6c.4-.8 1.7-.8 2.2.1Z",
    fill: "#FFD41F",
    stroke: "#F4C500",
    strokeWidth: 2.023
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel6);
export default __webpack_public_path__ + "static/media/level6.84b134a5.svg";
export { ForwardRef as ReactComponent };